/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT CARD DETAILS : STYLES --------------- ++++++++++ */
export default theme => ({
	carddetail: {
		minWidth: pxToEm(195),
		marginRight: pxToEm(30),
		marginBottom: pxToEm(20),
		'& .detail': {
			'&-label': {
				marginBottom: pxToEm(5)
			},
			'&-data': {
				color: `rgba(6, 43, 117, 0.5)`
			}
		},
        '& .datetime':{
			display: 'flex',
			flexDirection: 'column',
			'& .date':{
				marginBottom: pxToEm(3)
			},
			'& .time':{
				fontStyle: 'italic',
				fontSize: pxToEm(14)
			}
        },
		// '&.creator': 		{ minWidth: pxToEm(195), marginRight: pxToEm(25) },
		// '&.createdat': 		{ minWidth: pxToEm(220), marginRight: pxToEm(55) },
		// '&.lastrun': 		{ minWidth: pxToEm(220), marginRight: pxToEm(50) },
		// '&.schedule': 		{ minWidth: pxToEm(195), marginRight: pxToEm(50) },
		// '&.expireson': 		{ minWidth: pxToEm(195), marginRight: pxToEm(0) },
		'&:last-child': {
			marginRight: '0'
		}
	}
});
